export default "__VITE_ASSET__CUlv$DJX__"